
import Swal from 'sweetalert2';

export interface ErrorResponse {
    statusCode: number;
    errorMessage: string;
    errorDetail: string;
    errorES?: string | null;
    errorEN?: string | null;
}

class ErrorService {
    extractError(error: any): ErrorResponse {
        const responseData = error?.response?.data;
        const statusCode = responseData?.statusCode || error?.response?.status || 500;
        const errorMessage = responseData?.errorMessage || responseData?.message || error?.message || "Ocurrió un error inesperado";
        const errorDetail = responseData?.errorDetail || "No hay detalles adicionales sobre este error";

        return {
            statusCode: statusCode,
            errorMessage: errorMessage,
            errorDetail: errorDetail,
            errorES: responseData?.errorES || null,
            errorEN: responseData?.errorEN || null
        };
    }

    getDisplayMessage(error: any, preferredLang: 'es' | 'en' = 'es'): string {
        const processedError = error.statusCode ? (error as ErrorResponse) : this.extractError(error);

        const message = preferredLang === 'es' ? processedError.errorES : processedError.errorEN;

        return message || processedError.errorDetail;
    }

    showErrorAlert(error: any, title?: string): void {
        const processedError = error.statusCode ? (error as ErrorResponse) : this.extractError(error);
        const displayMessage = this.getDisplayMessage(processedError);

        Swal.fire({
            icon: 'error',
            title: title || `Error ${processedError.statusCode}`,
            text: displayMessage,
            confirmButtonColor: '#d32f2f' // Color acorde a la mayoría de temas de error
        });
    }

    isStatus(error: any, code: number): boolean {
        const processedError = error.statusCode ? (error as ErrorResponse) : this.extractError(error);
        return processedError.statusCode === code;
    }
}

export const errorService = new ErrorService();
